"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Builds a query from an object. Object can only contains string and number properties.
 * @param { T } Object
 * @returns { string } query
 */
function buildQueryString(object) {
    var queryString = '?';
    for (var key in object) {
        if (key) {
            var keyValue = createKeyValue(key, object[key]);
            if (keyValue.error) {
                var error = {
                    response: {
                        status: 500,
                        statusText: 'Invalid query',
                        data: null,
                        message: "invalid query for key " + keyValue.key + ": " + keyValue.error,
                    }
                };
                throw error;
            }
            queryString += keyValue.key + "=" + keyValue.value + "&";
        }
    }
    queryString = queryString.substring(0, queryString.length - 1);
    return queryString;
}
exports.buildQueryString = buildQueryString;
var simpleTypes = ['string', 'number'];
var simpleValues = [0, null];
function createKeyValue(key, value) {
    if (simpleTypes.some(function (type) { return type === typeof value; }) || simpleValues.includes(value)) {
        return { key: key, value: value, error: null };
    }
    if (Array.isArray(value)) {
        return createKeyValueArray(key, value);
    }
    return { key: key, value: null, error: 'Invalid key value pair' };
}
function createKeyValueArray(key, values) {
    var valueString = '';
    var error = null;
    values.forEach(function (a) {
        if (simpleTypes.some(function (type) { return type === typeof a; })) {
            valueString += a + ",";
        }
        else {
            error = JSON.stringify(a) + " can not be part of array";
        }
    });
    if (error) {
        return { key: key, value: null, error: error };
    }
    valueString = valueString.substring(0, valueString.length - 1);
    return { key: key, value: valueString, error: null };
}
//# sourceMappingURL=helpers.js.map